import { useEffect } from 'react';
import { ToastContainer, toast } from "react-toastify";
import useAuth from "../../hooks/useAuth";

function Toast2() {
  const act = JSON.parse(localStorage.getItem("sess"));
  const { logout } = useAuth();
   const notify = (x) => toast(x);

    useEffect(() => {
      if (act === "inactive") {
        notify("session has expired, redirecting...");
        const timeout = setTimeout(() => {
          logout();
        }, 4000);
        return () => clearTimeout(timeout);
      }
    }, [logout, act]);

  return (
    <ToastContainer
      position="bottom-right"
      autoClose={4000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
    />
  );
}

export default Toast2;
